module.exports = __webpack_public_path__ + "img/beuc.819034aa.png";